import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StatesComponent } from './states.component';
import { SharedModule } from '../common/shared.module';
import { StatesRoutingModule } from './states-routing.module';
import { BsDropdownModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [StatesComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    StatesRoutingModule,
    BsDropdownModule.forRoot()
  ]
})
export class StatesModule {}



// WEBPACK FOOTER //
// ./src/app/t6-states/states.module.ts